import El_choclo from "../assets/audio/El_choclo.mp3";
import Estrella_de_medianoche from "../assets/audio/Estrella_de_medianoche.mp3";
import Flor_de_lino from "../assets/audio/Flor_de_lino.mp3";
import Milonga_de_mis_amores from "../assets/audio/Milonga_de_mis_amores.mp3";

export const musicData = [
  {
    id: 1,
    author: "Á. Villoldo",
    title: "El choclo",
    music: El_choclo,
  },
  {
    id: 2,
    author: "H. Stamponi",
    title: "Flor de lino",
    music: Flor_de_lino,
  },
  {
    id: 3,
    author: "P. Laurenz",
    title: "Milonga de mis amores",
    music: Milonga_de_mis_amores,
  },
];
